import React from 'react'

import { SectionType, useGetTopPostQuery } from '@/generated/graphql'
import { PostCard } from '@/modules/post/post-card'

interface TopPostProps {
  groupId?: number
  sectionId?: SectionType
}

export const TopPost: React.FC<TopPostProps> = ({ groupId, sectionId }) => {
  const withGroupPost = !!groupId
  const withSectionPost = !!sectionId
  const { data, error } = useGetTopPostQuery({
    fetchPolicy: 'network-only',
    variables: {
      groupId: groupId || 0,
      sectionId: sectionId || SectionType.Null,
      withGroupPost,
      withSectionPost,
    },
  })

  const post = (() => {
    if (withGroupPost) {
      return data?.group!.topPost
    }
    return data?.section!.topPost
  })()

  if (error || !post) {
    return null
  }

  return <PostCard post={post} isSection={!!sectionId} isGroup={!!groupId} isTop={true} />
}
